import { type SelectInputProps, SelectInput, useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

import { type TrackerRecord } from "./types";

type TrackerInputProps = Pick<SelectInputProps, "source" | "validate"> & {
  alwaysOn?: boolean;
};

export const TrackerInput = ({
  source,
  validate,
  alwaysOn,
}: TrackerInputProps) => {
  const { isPending, isLoading, data } = useGetList<TrackerRecord>(
    MODULE_NAMES.TRACKERS,
  );

  return (
    <SelectInput
      isPending={isPending}
      isLoading={isLoading}
      validate={validate}
      alwaysOn={alwaysOn}
      source={source}
      optionValue="id"
      choices={data ?? []}
    />
  );
};
